var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7099 13.9999H15.4999L19.7399 18.2599C20.1499 18.6699 20.1499 19.3399 19.7399 19.7499C19.3299 20.1599 18.6599 20.1599 18.2499 19.7499L13.9999 15.4999V14.7099L13.7299 14.4299C12.3299 15.6299 10.4199 16.2499 8.38989 15.9099C5.60989 15.4399 3.38989 13.1199 3.04989 10.3199C2.52989 6.08989 6.08989 2.52989 10.3199 3.04989C13.1199 3.38989 15.4399 5.60989 15.9099 8.38989C16.2499 10.4199 15.6299 12.3299 14.4299 13.7299L14.7099 13.9999ZM4.99989 9.49989C4.99989 11.9899 7.00989 13.9999 9.49989 13.9999C11.9899 13.9999 13.9999 11.9899 13.9999 9.49989C13.9999 7.00989 11.9899 4.99989 9.49989 4.99989C7.00989 4.99989 4.99989 7.00989 4.99989 9.49989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6043883fa1cb60ee9f5cf2ad07f14803.svg";
export { ForwardRef as ReactComponent };